import { createStore$ } from '../createStore$';
import React from 'react';
import { Native$ } from './Native$';
import isOnline from 'is-online';
import { XSButton } from '../xs/component/button/XSButton';

type State = {
    colorScheme?: 'auto' | 'dark' | 'light';
    persistedUrl?: string;
};

const store = createStore$<State>({
    cacheKey: 'DeviceState$',
    initialState: {},
});

export namespace DeviceState$ {
    export const useState = store.useState;

    export function hasInternet() {
        return hasInternet$.useValue();
    }

    export function usePersistedUrl() {
        const [url, setState] = store.useState((state) => state.persistedUrl);

        return {
            url: url,
            setUrl(url: string) {
                setState((state) => {
                    state.persistedUrl = url;
                });
            },
        };
    }

    export function ButtonColorScheme() {
        const [deviceState, setDeviceState] = store.useState();

        return (
            <XSButton
                label={'Theme'}
                icon={
                    (deviceState.colorScheme === 'dark' && 'dark_mode') ||
                    (deviceState.colorScheme === 'light' && 'light_mode') ||
                    'hdr_auto'
                }
                fill={'none'}
                onClick={() => {
                    setDeviceState((state) => {
                        if (state.colorScheme === 'dark') {
                            state.colorScheme = 'light';
                        } else if (state.colorScheme === 'light') {
                            state.colorScheme = undefined;
                        } else {
                            state.colorScheme = 'dark';
                        }
                    });
                }}
            />
        );
    }
}

/**
 * INTERNET
 */

const hasInternet$ = createStore$<boolean>({ initialState: true });

window.setInterval(() => isOnline().then(hasInternet$.setValue).catch(console.error), 30 * 1000);
window.addEventListener('offline', () => hasInternet$.setValue(false));
window.addEventListener('online', () => hasInternet$.setValue(true));

/**
 * COLOR SCHEME
 */

const colorSchemeListener = window.matchMedia('(prefers-color-scheme: dark)');
const colorScheme$ = createStore$<'dark' | 'light'>({ initialState: colorSchemeListener.matches ? 'dark' : 'light' });
store.state.subscribe(handleHtmlColorSchemeAttribute);
colorScheme$.state.subscribe(handleHtmlColorSchemeAttribute);

function handleHtmlColorSchemeAttribute() {
    const colorSchemePersisted = store.state.getValue().colorScheme;
    const colorSchemeSystem = colorScheme$.state.getValue();
    const colorScheme = colorSchemePersisted || colorSchemeSystem;
    document.documentElement.setAttribute('color-scheme', colorScheme);

    if (Native$.isNative) {
        Native$.execute('setColorScheme', colorScheme).catch(console.error);
    }
}

colorSchemeListener.addEventListener('change', ({ matches }) => {
    colorScheme$.setValue(matches ? 'dark' : 'light');
});
